import { useLocale } from "next-intl";

export default function AuthHero() {
  const locale = useLocale();
  const isRtl = locale === "ar";

  return (
    <div className="hidden lg:block lg:w-1/2 lg:min-h-screen relative overflow-hidden select-none group">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 group-hover:scale-110"
        style={{ backgroundImage: "url('/auth.png')" }}
      />
      <div className="absolute inset-0 bg-linear-to-t from-main/90 via-main/20 to-transparent" />

      <div className="absolute bottom-12 left-12 right-12 text-white z-10 animate-in fade-in slide-in-from-bottom-10 duration-1000">
        <h1 className="text-4xl font-black mb-4">SNA Alaqaria</h1>
        <p className="text-lg text-white/80 leading-relaxed max-w-md">
          {isRtl
            ? "بوابتك نحو استثمار عقاري آمن وذكي في المملكة."
            : "Your gateway to secure and smart real estate investment in the Kingdom."}
        </p>
      </div>
    </div>
  );
}
